import { Routes } from '@angular/router';
import { ConfirmSubscriptionComponent } from './features/subscription/components/confirm-subscription/confirm-subscription.component';
import { EditSubscriptionComponent } from './features/subscription/components/edit-subscription/edit-subscription.component';
import { SearchSubscriptionComponent } from './features/subscription/components/search-subscription/search-subscription.component';
import { InPersonRegistrationComponent } from './features/registration/components/in-person-registration/in-person-registration.component';
import { OnlineRegistrationComponent } from './features/registration/components/online-registration/online-registration.component';
import { Survey123RegistrationComponent } from './features/registration/components/survey-123-registration/survey-123-registration.component';
import { NewStakeholderRegistrationComponent } from './features/registration/components/new-stakeholder-registration/new-stakeholder-registration.component';
import { InPersonConfirmationComponent } from './features/registration/components/in-person-registration/in-person-confirmation/in-person-confirmation.component';
import { OnlineConfirmationComponent } from './features/registration/components/online-registration/online-confirmation/online-confirmation.component';
import { Survey123ConfirmationComponent } from './features/registration/components/survey-123-registration/survey-123-confirmation/survey-123-confirmation.component';
import { ProjectGuidGuard } from './core/project-guid.guard';
import { ErrorComponent } from './shared/components/error/error.component';
import { RsvpSearchComponent } from './features/rsvp/components/rsvp-search/rsvp-search.component';
import { RsvpEditComponent } from './features/rsvp/components/rsvp-edit/rsvp-edit.component';
import { RsvpConfirmComponent } from './features/rsvp/components/rsvp-confirm/rsvp-confirm.component';

export const routes: Routes = [
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  {
    path: 'home',
    loadComponent: () => import('./features/home/home.component').then((m) => m.HomeComponent),
  },
  {
    path: 'comment',
    loadComponent: () =>
      import('./features/comment/comment.component').then((m) => m.CommentComponent),
  },
  {
    path: 'event-comment',
    loadComponent: () =>
      import('./features/comment/comment.component').then((m) => m.CommentComponent),
  },
  {
    path: 'online-meetings',
    loadComponent: () =>
      import('./features/online-meetings/online-meetings.component').then(
        (m) => m.OnlineMeetingsComponent
      ),
  },
  {
    path: 'subscription',
    loadComponent: () =>
      import('./features/subscription/subscription.component').then((m) => m.SubscriptionComponent),
    children: [
      {
        path: 'search',
        component: SearchSubscriptionComponent,
      },
      {
        path: 'edit',
        component: EditSubscriptionComponent,
      },
      {
        path: 'confirm',
        component: ConfirmSubscriptionComponent,
      },
      { path: 'profile', component: EditSubscriptionComponent },
      { path: '', redirectTo: 'search', pathMatch: 'full' },
    ],
  },
  {
    path: 'rsvp',
    loadComponent: () => import('./features/rsvp/rsvp.component').then((m) => m.RsvpComponent),
    children: [
      {
        path: 'search',
        component: RsvpSearchComponent,
      },
      {
        path: 'edit',
        component: RsvpEditComponent,
      },
      {
        path: 'confirm',
        component: RsvpConfirmComponent,
      },
    ],
  },
  {
    path: 'comment-thread',
    loadComponent: () =>
      import('./features/comment-thread/comment-thread.component').then(
        (m) => m.CommentThreadComponent
      ),
  },
  {
    path: 'registration',
    loadComponent: () =>
      import('./features/registration/registration.component').then((m) => m.RegistrationComponent),
    children: [
      {
        path: 'in-person',
        component: InPersonRegistrationComponent,
      },
      {
        path: 'in-person/confirmation',
        component: InPersonConfirmationComponent,
      },
      {
        path: 'online',
        component: OnlineRegistrationComponent,
      },
      {
        path: 'online/confirmation',
        component: OnlineConfirmationComponent,
      },
      {
        path: 'survey123',
        component: Survey123RegistrationComponent,
      },
      {
        path: 'survey123/confirmation',
        component: Survey123ConfirmationComponent,
      },
      {
        path: 'new-stakeholder',
        component: NewStakeholderRegistrationComponent,
      },
    ],
  },
  { path: 'error', component: ErrorComponent },
  { path: '**', redirectTo: '/error' },
];
